import React, { useEffect, useState } from "react";
import "./DueOverduePieChart.scss";
import { commaFormat } from "../../utils/Helper";

import { Doughnut } from "react-chartjs-2";

interface IDueOverdueProps {
  invoicesDue: number;
  invoicesOverdue: number;
  invoicesUnpaid: number;
}

const DueOverduePieChart: React.FC<IDueOverdueProps> = ({
  invoicesDue,
  invoicesOverdue,
  invoicesUnpaid,
}) => {
  const [pieChartData, setPieChartData] = useState<any>(null);
  const [duePercentage, setDuePercentage] = useState<string>("0%");
  const [overduePercentage, setOverduePercentage] = useState<string>("0%");
  const [dueAmount, setDueAmount] = useState<number>(0);
  const [overdueAmount, setOverdueAmount] = useState<number>(0);

  useEffect(() => {
    generatePieChartData(invoicesOverdue, invoicesDue);
  }, [invoicesDue, invoicesOverdue]);

  const generatePieChartData = (overdue: number, due: number) => {
    const total = due + overdue;
    const duePerc = total === 0 ? 0 : (due / total) * 100;
    const overduePerc = total === 0 ? 0 : (overdue / total) * 100;

    setDuePercentage(`${duePerc.toFixed(0)}%`);
    setOverduePercentage(`${overduePerc.toFixed(0)}%`);
    setDueAmount(due);
    setOverdueAmount(overdue);

    const data = {
      labels: ["Due", "Overdue"],
      datasets: [
        {
          data: [due, overdue],
          backgroundColor: ["#FEC400", "#4D4DFF"],
          borderWidth: 0,
        },
      ],
    };

    const options = {
      cutout: "65%",
      plugins: {
        legend: { display: false },
        tooltip: {
          callbacks: {
            label: function (context: any) {
              return `${context.label}: ${commaFormat(context.raw.toString())}`;
            },
          },
        },
      },
    };

    setPieChartData({ data, options });
  };

  return (
    <div className="circular-pie-chart-main-wrapper py-12 flex-column gap-9">
      <p style={{ color: "#333333" }} className="xetgo-font-button bold px-14">
        Total Payable – ₹{commaFormat(invoicesUnpaid.toString())}
      </p>
      <div className="flex-row align-items-center justify-content-center">
        <div className="pie-chart-container">
          {pieChartData && (
            <Doughnut data={pieChartData.data} options={pieChartData.options} />
          )}
        </div>
      </div>

      <div className="total-due-detail-container px-16 flex-row align-items-center justify-content-space-between gap-16">
        <div className="flex-column gap-3">
          <div className="flex-row align-items-center gap-4">
            <p className="overdue-point-circle due-point-circle"></p>
            <p style={{ color: "#A3AED0" }} className="xetgo-font-tag">
              Due
            </p>
          </div>
          <div className="flex-column gap-7 px-13">
            <p className="xetgo-font-tag bolder">{duePercentage}</p>
            <p className="amount xetgo-font-button bold">
              ₹{commaFormat(dueAmount.toString())}
            </p>
          </div>
        </div>
        <p className="center-line"></p>
        <div className="flex-column gap-3">
          <div className="flex-row align-items-center gap-4">
            <p className="overdue-point-circle"></p>
            <p style={{ color: "#A3AED0" }} className="xetgo-font-tag">
              Over-Due
            </p>
          </div>
          <div className="flex-column gap-7 px-13">
            <p className="xetgo-font-tag bolder">{overduePercentage}</p>
            <p className="amount xetgo-font-button bold">
              ₹{commaFormat(overdueAmount.toString())}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DueOverduePieChart;
